import { Fragment } from 'react';
import { Typography } from '../../../../core/components/molecules/Typography';

interface ICardContentAudio {
  time: string;
}

export function CardContentAudio({ time }: ICardContentAudio) {
  return (
    <Fragment>
      <Typography className='transition delay-100 ease-in-out group-hover:text-card-color-default'>
        {time}
      </Typography>
    </Fragment>
  );
}
